import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useComponentVisible } from '../hooks';
import { ReactComponent as CaretDownIcon } from '../assets/images/caret-down.svg';

const Wrapper = styled.div`
  position: relative;
  .dropdown-menu.show {
    min-width: -webkit-fill-available !important;
  }
`;

const DropdownButton = ({ title, className, style, children, disabled }) => {
  const { ref, isComponentVisible } = useComponentVisible(false, false, '', disabled);
  // const [expand, setExpand] = React.useState(false);
  return (
    <Wrapper className="items-wrapper" style={style}>
      <button
        ref={ref}
        type="button"
        className={`${className} btn-dropdown-toggler`}
        disabled={disabled}
      >
        <div className="d-flex align-items-center gap-2">
          <span className="">{title}</span>
          <CaretDownIcon />
        </div>
      </button>
      <div className={`dropdown-menu dropdown-menu-left ${isComponentVisible ? ' show' : ''}`}>
        {children}
      </div>
    </Wrapper>
  );
};

DropdownButton.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  style: PropTypes.instanceOf(Object),
  children: PropTypes.node.isRequired
};

DropdownButton.defaultProps = {
  title: '',
  className: 'btn',
  style: {}
};

export default DropdownButton;
